
define(
	'MHIShopping.Shopping'
,   [
		'Facets.CategoryCell.View',
		'Facets.ItemCell.View'
	]
,   function ( FacetsCategoryCellView, FacetsItemCellView )
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			FacetsCategoryCellView.prototype.getContext = _.wrap( FacetsCategoryCellView.prototype.getContext, function (fn) {
				var context = fn.apply(this, _.toArray(arguments).slice(1));
				context.urlfragment = this.model.get('urlfragment');
				return context;
			});
			FacetsItemCellView.prototype.getContext = _.wrap( FacetsItemCellView.prototype.getContext, function (fn) {
				var context = fn.apply(this, _.toArray(arguments).slice(1));
				context.sku = this.model.get('itemid');
				context.size = this.model.get('custitem_mhi_website_size') || 'N/A';
				context.brand = this.model.get('custitem_mhi_brand') || 'N/A';
				return context;
			});

			/* var layout = container.getComponent('Layout');
			layout.addToViewContextDefinition(
				'Facets.ItemCell.View',
				'sku',
				'string',
				function (context) {
					var sku = context.sku;
					return sku;
				}
			); */
		}
	};
});
